module.exports = __webpack_public_path__ + "static/media/estilo4.815bd584.png";